import React from 'react';
import './AboutUs.css';
function AboutUs() {
  return (
    <section className='about-us'>
      <h1 style={{marginTop:'0px'}}>About Us</h1> 
      <p>
      <strong>Knowledge Buddy</strong> is your friendly companion on the journey to mastering programming and technology. Our mission is to make learning accessible, engaging, and effective for everyone, whether you're a complete beginner or looking to sharpen your skills.
    </p>

    <h2>Our Story</h2>
    <p>
      Founded in 2024 by a group of passionate developers and educators, Knowledge Buddy was created to bridge the gap between complex technical concepts and easy-to-understand tutorials. We believe that everyone should have the opportunity to learn and grow in the digital age.
    </p>
    <h2>What We Offer</h2>
    <ul>
      <li><strong>Step-by-step Tutorials:</strong> Clear, concise guides on popular programming languages and tools.</li>
      <li><strong>Real-world Examples:</strong> Practical code snippets and projects to help you apply what you learn.</li>
      <li><strong>Community Support:</strong> A welcoming space to ask questions, share knowledge, and connect with fellow learners.</li>
    </ul>

    <h2>Meet the Team</h2>
    <div style={{display: 'flex', gap: '2rem', flexWrap: 'wrap', marginBottom: '2rem'}}>
    {/* <div style={{flex:1, minWidth:'180px', maxWidth:'220px', background:'#fff', borderRadius:'1rem', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', padding:'1.2rem', textAlign:'center'}}>
        <img src="https://img.icons8.com/ios-filled/64/4fd1c5/user-male-circle.png" alt="Team Member" style={{borderRadius:'50%', marginBottom:'0.5rem'}}/>
        <h3 style={{margin:'0.3rem 0 0.1rem 0'}}>Alex Kim</h3>
        <p style={{margin:'0px', fontSize:'0.98rem', color:'#555'}}>Lead Developer</p>
      </div> */}
      {/* <div style={{flex:1, minWidth:'180px', maxWidth:'220px', background:'#fff', borderRadius:'1rem', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', padding:'1.2rem', textAlign:'center'}}>
        <img src="https://img.icons8.com/ios-filled/64/4fd1c5/user-female-circle.png" alt="Team Member" style={{borderRadius:'50%', marginBottom:'0.5rem'}} />
        <h3 style={{margin:'0.3rem 0 0.1rem 0'}}>Priya Patel</h3>
        <p style={{margin:0, fontSize:'0.98rem', color:'#555'}}>Content Creator</p>
      </div> */}
    </div>

    <h2>Contact Us</h2>
    <p>
      Have questions, suggestions, or want to contribute? Reach out to us at <a href="mailto:hello@knowledgebuddy.com">hello@knowledgebuddy.com</a> {/*or visit our <a href="/pages/contact.html">Contact</a> page */}.
    </p>
    <p>
      Thank you for being a part of our learning community!
    </p>


     </section>
  )
}

export default AboutUs